// https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-react/docs/performance.md#how-to-configure-azuremsal-react-to-use-your-routers-navigate-function-for-client-side-navigation

import {NavigationClient} from '@azure/msal-browser';

import type {router} from '@/router/router';
import type {NavigationOptions} from '@azure/msal-browser';

export class CustomNavigationClient extends NavigationClient {
  navigate: typeof router.navigate;

  constructor(navigate: typeof router.navigate) {
    super();

    this.navigate = navigate;
  }

  override async navigateInternal(url: string, options: NavigationOptions) {
    // Use history API instead of the router's navigate() to avoid triggering
    // route loaders before MSAL has finished storing tokens and firing LOGIN_SUCCESS.
    // The router's Transitioner picks up the correct URL once auth completes.
    const relativePath = url.replace(window.location.origin, '');
    if (options.noHistory) {
      window.history.replaceState(null, '', relativePath);
    } else {
      window.history.pushState(null, '', relativePath);
    }
    return false;
  }
}
